const zh_wyrmprints = {
  400001: '奮勇戒指',
  400002: '美味海鮮湯',
  400003: '龍族密藥',
  400004: '瑪納靈地',
  400005: '陳舊的豎琴',
  400006: '名馬斯賈巴德',
  400007: '聖光之環',
  400008: '午茶時光',
  400009: '芭萊朵納之花',
  400010: '阿爾貝利亞國旗',
  400011: '破天號角',
  400012: '巔頂長嘯的獠牙',
  400013: '「結社」的面具',
  400014: '遙遠的靈峰',
  400015: '森林與湖畔之歌',
  400016: '龍族之床',
  400017: '秘傳之書',
  400018: '鐵騎兵之盾',
  400019: '聖魯塔斯之風',
  400020: '香氛燈',
  400021: '幸運八葉草',
  400022: '被封印的遺物',
  400023: '戰士的追夢殘跡',
  400024: '「古理莫爾斯之索引」抄本',
  400025: '闇夜宣告',
  400026: '明日之轍',
  400027: '榮耀之光・高照・阿爾貝利亞！',
  400028: '聖草魔藥香草',
  400029: '昔日之冠',
  400030: '',
  400031: '不融冰',
  400032: '南瓜快樂桶',
  400033: '百刃撩亂',
  400034: '命運的救贖',
  400035: '性感・狙擊手',
  400036: '雨天的回憶',
  400037: '火熱女子會',
  400038: '我們就是智囊團',
  400039: '生存日誌',
  400040: '天空的霸主',
  400041: '王之尊嚴',
  400042: '踏向未知的一步',
  400043: '真是給人添麻煩！',
  400044: '在此撤退吧！',
  400045: '將此身化為暗影',
  400046: '命懸一線的愉悅戰鬥',
  400047: '盔甲師的大志',
  400048: '魔法研究新成果',
  400049: '鍛冶屋三姊妹的羈絆',
  400050: '飆舞大賽！',
  400051: '戰場上的兩人',
  400052: '受傷就交給我治療',
  400053: '聖騎士的守護',
  400054: '為了成為強大的男人',
  400055: '五龍咆嘯：耶夢加得',
  400056: '五龍咆嘯：墨丘利',
  400057: '五龍咆嘯：布倫希爾德',
  400058: '五龍咆嘯：朱庇特',
  400059: '五龍咆嘯：索狄亞克',
  400060: '致命佳麗',
  400061: '西爾琪的協助',
  400062: '英勇王冠',
  400063: '天才的靈光乍現',
  400064: '豪華盛宴',
  400065: '勁敵',
  400066: '神聖的禱告',
  400067: '龍之血族',
  400068: '琉卡的惡作劇',
  400069: '昔日的幸福時光',
  400070: '雷維翁的英雄',
  400071: '狩獵之夜',
  400072: '暴風之譽',
  400073: '聚集於理想之下的人們',
  400074: '克菈兒的計謀',
  400075: '魔鬼教官的聲援',
  400076: '冰晶少女',
  400077: '萬聖節・巫女・魔造秘點',
  400078: '搗蛋・給糖・搗蛋',
  400079: '',
  400080: '戰旗少女',
  400081: '',
  400082: '',
  400083: '歷經悠久歲月',
  400084: '古老盟約',
  400085: '美麗的秘訣',
  400086: '',
  400087: '甜點掠賊',
  400088: '',
  400089: '',
  400090: '腳踏實地的宣傳活動',
  400091: '向星龍樹祈願',
  400092: '手工巧克力・教學',
  400093: '旅途的護衛',
  400094: '',
  400095: '阿魯庫托斯的猛烈特訓！',
  400096: '新娘是龍族',
  400097: '兩人的羈絆',
  400098: '聖夏的聖騎士',
  400099: '寶石與劍',
  400100: '武士們的休息時光',
  400101: '出遊日的特製便當',
  400102: '艷烈二人組',
  400103: '風中溫情',
  400104: '優美烈風',
  400105: '陌生的視界',
  400106: '迦樓羅的羽毛',
  400107: '路易潔的喜好',
  400108: '蒼海女王',
  400109: '',
  400110: '傳渡世間的歌聲',
  400111: '聖職者的休假日',
  400112: '某日的溫暖陽光',
  400113: '秘密的朋友',
  400114: '雪落之街',
  400115: '星龍祭的王子殿下',
  400116: '孩子們的星龍祭',
  400117: '星落之夜的晚餐',
  400118: '星龍祭的特製蛋糕',
  400119: '頂級款待',
  400120: '',
  400121: '火山女王',
  400122: '',
  400123: '獻給你的禮物',
  400124: '謹賀新年',
  400125: '來自日初之國的使者',
  400126: '羽子板對決！',
  400127: '新年最初的籤運',
  400128: '龍族馬戲團',
  400129: '最佳表現',
  400130: '閃亮的場所',
  400131: '精彩的把戲',
  400132: '',
  400133: '',
  400134: '',
  400135: '星夜中的魔女們',
  400136: '春節的祭典',
  400137: '仙花焰',
  400138: '龍之舞',
  400139: '薔薇貴公子',
  400140: '炎之饗宴',
  400141: '致最愛之人',
  400142: '薔薇妖精',
  400143: '嬌心備禮',
  400144: '男子漢的情人節',
  400145: '心跳加速★約會時光',
  400146: '優雅護衛',
  400147: '請將手交給我',
  400148: '坦率時刻',
  400149: '',
  400150: '黑暗中的曙光',
  400151: '達比亞濕地',
  400152: '惹人憐愛的舞姬',
  400153: '真實探究者',
  400154: '虛幻少女',
  400155: '',
  400156: '異端研究室',
  400157: '不擅長念書？',
  400158: '萬雷之王',
  400159: '',
  400160: '',
  400161: '',
  400162: '',
  400163: '功夫之道',
  400164: '',
  400165: '',
  400166: '',
  400167: '光輝之霸主',
  400168: '夢中的校園生活𝅘𝅥𝅮',
  400169: '',
  400170: '',
  400171: '師父的當頭棒喝',
  400172: '森林編織之絆',
  400173: '',
  400174: '蛋上所繪之夢',
  400175: '小小的紙糊龍偶',
  400176: '母愛',
  400177: '',
  400178: '',
  400179: '',
  400180: '',
  400181: '',
  400182: '',
  400183: '',
  400184: '',
  400185: '',
  400186: '',
  400187: '',
  400188: '',
  400189: '',
  400190: '',
  400191: '',
  400192: '',
  400193: '',
  400194: '',
  400195: '',
  400196: '',
  400197: '',
  400198: '',
  400199: '',
  400200: '',
  400201: '',
  400202: '',
  400203: '',
  400204: '',
  400205: '',
  400206: '',
  400207: '',
  400208: '',
  400209: '',
  400210: '',
  400211: '',
  400212: '',
  400213: '',
  400214: '',
  400215: '',
  400216: '',
  400217: '',
  400218: '',
  400219: '',
  400220: '',
  400221: '',
  400222: '',
  400223: '',
  400224: '',
  400225: '',
  400226: '',
  400227: '',
  400228: '',
  400229: '',
  400230: '',
  400231: '',
  400232: '',
  400233: '',
  400234: '',
  400235: '',
  400236: '',
  400237: '',
  400238: '',
  400239: '',
  400240: '',
  400241: '',
  400242: '',
  400243: '三姊妹的日常',
  400244: '',
  400245: '龍族鍛冶屋',
  400246: '',
  400247: '',
  400248: '',
  400249: '',
  400250: '',
  400251: '',
  400252: '',
  400253: '',
  400254: '',
  400255: '',
  400256: '',
  400257: '',
  400258: '',
  400259: '',
  400260: '',
  400261: '',
  400262: '',
  400263: '',
  400264: '',
  400265: '',
  400266: '',
  400267: '',
  400268: '',
  400269: '',
  400270: '',
  400271: '',
  400272: '',
  400273: '',
  400274: '',
  400275: '',
  400276: '',
  400277: '英雄到來',
  400278: '',
  400279: '特務機關的傳信貓頭鷹',
  400280: '超越時空的友情',
  400281: '',
  400282: '聖城的新郎們',
  400283: '',
  400284: '',
  400285: '與主廚共享早餐',
  400286: '三葉的入門教學',
  400287: '',
  400288: '可愛的森林居民',
  400289: '',
  400290: '',
  400291: '',
  400292: '',
  400293: '短暫的安祥時光',
  400294: '',
  400295: '',
  400296: '',
  400297: '',
  400298: '',
  400299: '',
  400300: '',
  400301: '',
  400302: '',
  400303: '',
  400304: '',
  400305: '',
  400306: '',
  400307: '',
  400308: '',
  400309: '',
  400310: '',
  400311: '',
  400312: '',
  400313: '',
  400314: '',
  400315: '',
  400316: '',
  400317: '',
  400318: '',
  400319: '',
  400320: '',
  400321: '',
  400322: '',
  400323: '',
  400324: '',
  400325: '',
  400326: '',
  400327: '',
  400328: '',
  400329: '',
  400330: '',
  400331: '',
  400332: '',
  400333: '',
  400334: '無法忘懷的夏日',
  400335: '敲響太鼓吧！',
  400336: '海邊的沙灘搶旗',
  400337: '傳教師的假期',
  400338: '海濱王女',
  400339: '海之家的盛況',
  400340: '衝浪兄妹',
  400341: '',
  400342: '',
  400343: '',
  400344: '',
  400345: '',
  400346: '',
  400347: '',
  400348: '',
  400349: '',
  400350: '',
  400351: '',
  400352: '',
  400353: '',
  400354: '',
  400355: '',
  400356: '',
  400357: '',
  400358: '',
  400359: '',
  400360: '',
  400361: '',
  400362: '',
  400363: '',
  400364: '',
  400365: '',
  400366: '',
  400367: '',
  400368: '',
  400369: '',
  400370: '',
  400371: '',
  400372: '',
  400373: '',
  400374: '',
  400375: '',
  400376: '',
  400377: '',
  400378: '',
  400379: '狂亂呼嘯的暴風',
  400380: '我們是聖城應援團！',
  400381: '優美的虛無',
  400382: '闇影統御者',
  400383: '',
  400384: '無盡的華爾滋',
  400385: '白燕騎士團的互補搭檔',
  400386: '',
  400387: '妖豔的宮廷魔法師',
  400388: '歌劇風‧化妝舞會',
  400389: '致「悠久之主」',
  400390: '來自彼方',
  400391: '只屬於我的琉卡卡☆☆☆',
  400392: '喔啦！我騎爆走戰車來囉！',
  400393: '專屬於你的禮物',
  400394: '閃閃亮亮☆璀璨聖夜',
  400395: '哮天夜狼',
  400396: '毛茸茸樂園',
  400397: '共鳴的勇氣',
  400398: '威利博士的刺客們‧Ｂ＆Ｗ',
  400399: '威利博士的刺客們‧Ａ＆Ｃ',
  400400: '威利博士的刺客們‧Ｍ＆Ｑ',
  400401: '威利博士的刺客們‧Ｆ＆Ｈ',
  400402: '',
  400403: '',
  400404: '',
  400405: '',
  400406: '貓豬戲畫',
  400407: '兩位十二龍氏，到來！',
  400408: '新年的開始',
  400409: '昔日的記憶',
  400410: '帶來疾病之人',
  400411: 'Owaranai Sekaide',
  400412: '洛克蘿露大冒險',
  400413: '矛盾之炎',
  400414: '交給女僕部隊吧！',
  400415: '天空王者',
  400416: '身著漆黑應戰',
  400417: '艾路的款待',
  400418: '潛伏森林深處之物',
  400419: '聖城收到的委託',
  400420: '',
  400421: '',
  400422: '',
  400423: '',
  400424: 'STRANGELAND',
  400425: '',
  400426: '',
  400427: '',
  400428: '',
  400429: '',
  400430: '',
  400431: '開春夜空之輝煌煙花'
}

export default zh_wyrmprints